import { render } from "./home-bestseller-sec.vue?vue&type=template&id=04be099a&scoped=true"
import script from "./home-bestseller-sec.vue?vue&type=script&lang=js"
export * from "./home-bestseller-sec.vue?vue&type=script&lang=js"

import "./home-bestseller-sec.vue?vue&type=style&index=0&id=04be099a&scoped=true&lang=css"
import "./home-bestseller-sec.vue?vue&type=style&index=1&id=04be099a&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04be099a"]])

export default __exports__